<template>
  <div>
    <vs-popup :title="$t('Assign')" style="z-index:9999999" v-if="inAddMode" :active.sync="inAddMode">
      <div>
        <v-select label="Email"
                  :closeOnSelect="true"
                  v-model="reviewersToAdd"
                  :options="userCollection" />
      </div>
      <div :style="CadenceValue == '-1' ? {'height': '320px'} : {'height': '150px'}">
        <div>
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mb-base">
              <p>{{ $t('SetReviewCadence') }}</p>
              <v-select v-model="CadenceType" :options="CadenceOptions">
              </v-select>
            </div>
          </div>
        </div>
        <datepicker v-if="CadenceValue == '-1'" :value="date" @selected="setDate"></datepicker>
      </div>
      <vs-button @click="AssignReviewer">{{$t('Assign')}}</vs-button>
    </vs-popup>
    <div style="height:400px;">
      <vs-table :data="reviewerCollection">
        <template slot="thead">
          <vs-th style="min-width:150px;">{{$t('Reviewer')}}</vs-th>
          <vs-th>{{$t('Cadence')}}</vs-th>
          <vs-th>{{$t('DateDue')}}</vs-th>
          <vs-th>{{$t('CardActions')}}</vs-th>
        </template>

        <template v-slot="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.Email" valign="top">
              {{ tr.Email }}
            </vs-td>

            <vs-td :data="tr.Cadence" valign="top">
              <div v-if="tr.Cadence">
                <strong>{{getLabelByValue(tr.Cadence) }}</strong>
              </div>
              <span v-else class="text-muted">{{$t('NotSure')}}</span>
            </vs-td>

            <vs-td :data="tr.DateDue" valign="top">
              <span v-if="tr.DateDue">{{ formatDate(tr.DateDue) }}</span>
            </vs-td>

            <vs-td valign="top">
              <vs-button color="danger"
                         @click="UnassignSchedule(tr.UserId, indextr)"
                         icon="delete"
                         size="small"
                         class="ml-2" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="flex justify-center">
        <vs-button color="success" @click="OpenAddMenu" style="width:150px;" size="medium">+</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import vSelect from 'vue-select'
  import UserList from "@/views/components/extra-components/users/UserList.vue";
  import { VueTabs, VTab } from "vue-nav-tabs";
  import moment from "vue-moment";
  import Datepicker from 'vuejs-datepicker';

  export default {
    data() {
      return {
        userCollection: [],
        isLoading: true,
        reviewerCollection: null,
        reviewersToAdd: null,
        chosenReviewers: null,
        CadenceValue: null,
        CadenceType: null,
        inAddMode: false,
        CadenceOptionsRaw: [
          { key: 'Now', value: '0' },
          { key: 'Daily', value: '1' },
          { key: 'Weekly', value: '7' },
          { key: 'Monthly', value: '30' },
          { key: 'Quarterly', value: '90' },
          { key: 'Yearly', value: '365' },
          { key: 'SpecificDate', value: '-1' },
        ],
        date: new Date()
      }

    },


    props: ["onboardingId", "type"],
    mounted() {
      this.LoadReviewersAndUsers()
      this.CadenceValue = '0'
      this.CadenceType = this.CadenceOptions[0];
    },
    computed: {
      CadenceOptions() {
        return this.CadenceOptionsRaw.map(o => ({ label: this.$t(o.key), value: o.value }))
      }
    },
    watch: {
      "CadenceType": function (newval, oldval) {
        if (newval) {
          this.CadenceValue = newval.value;
        }
        else
          this.CadenceValue = '0';
      },
    },
    methods: {
      LoadReviewersAndUsers() {
        var instance = this;

        TCVelikClient.GetRelative("/api/onboarding/OnboardingSchedule?onboardingId=" + this.onboardingId + "&type=" + this.type)
          .then(function (response) {
            if (response) {
              instance.reviewerCollection = response.data.filter((x) => x.OnboardingId > 0)
              instance.userCollection = response.data
            }
          }).catch(err => {
            instance.$vs.notify({
              title: "There was an error fethcing the reviewers.",
              color: "danger",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          })

      },

      getLabelByValue(value) {
        const option = this.CadenceOptions.find(opt => opt.value === value.toString());
        return option ? option.label : null; // return null if not found
      },

      OpenAddMenu() {
        this.inAddMode = true
      },

      setDate(date) {
        this.date = date
      },

      formatDate(dateString) {
        const moment = require("moment");
        return moment(dateString).format('MMM DD, YYYY');
      },

      AssignReviewer() {
        var instance = this;
        const query = `
  mutation AssignSchedule($assignScheduleDTO: AssignScheduleDTOInput!) {
    assignSchedule(assignScheduleDTO: $assignScheduleDTO)
  }
`;

        const req = {
          query,
          variables: {
            assignScheduleDTO: {
              onboardingId: this.onboardingId,
              userId: this.reviewersToAdd.UserId,
              dateDue: this.date.toISOString(),
              cadence: this.CadenceValue * 1,
              type: this.type * 1
            }
          }
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data.assignSchedule == true) {
            instance.$vs.notify({
              title: "Assinged reviewer to onboaring.",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });

            var tempDate = instance.date
            if (instance.CadenceValue == '-1') {
              tempDate = instance.date
            }
            else {
              tempDate.setDate(instance.date.getDate() + instance.CadenceValue * 1)
            }

            instance.reviewerCollection.push({
              Email: instance.reviewersToAdd.Email,
              UserId: instance.reviewersToAdd.UserId,
              DateDue: tempDate,
              Cadence: instance.CadenceValue

            })

            instance.reviewersToAdd = ""
            instance.date = new Date()

          }
          else if (response && response.data && response.data.data.assignSchedule == false) {
            instance.$vs.notify({
              title: "Could not assign reviewer to onboaring.",
              color: "danger",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        });
      },

      UnassignSchedule(userId, index) {
        var instance = this;
        const query = `
  mutation UnassignSchedule($userId: String!, $onboardingId: Int!,$type:Int!) {
    unassignSchedule(userId:$userId,onboardingId:$onboardingId,type:$type)
}
     `;

        const req = {
          query,
          variables: {
            onboardingId: this.onboardingId,
            userId: userId,
            type: this.type
          }
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.reviewerCollection.splice(index, 1)
            instance.$vs.notify({
              title: "Unassigned reviewer from onboaring.",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors fetching the assigned roles');
          }
        });
      },

    },


    components: {
      vSelect,
      UserList,
      VueTabs,
      VTab,
      moment,
      Datepicker
    }
  }
</script>

<style scoped>
</style>

